import * as THREE from "three";

import Experience from "../../Experience.js";
import vertexShader from "./shaders/vertex.glsl";
import fragmentShader from "./shaders/fragment.glsl";
import worleyFragmentShader from "./shaders/worleyFragment.glsl";

function NoisesMaterial() {
    const material = new THREE.ShaderMaterial({
        uniforms: {},
        vertexShader: vertexShader,
        fragmentShader: fragmentShader,
    });

    return material;
}

function WorleyMaterial() {
    const material = new THREE.ShaderMaterial({
        uniforms: {},
        vertexShader: vertexShader,
        fragmentShader: worleyFragmentShader,
    });

    return material;
}

export default class Noises {
    constructor() {
        this.experience = new Experience();
        this.renderer = this.experience.renderer.instance;
        this.scene = this.experience.scene;

        this.setCustomRender();
        this.setMaterial();
        this.setWorleyMaterial();
        this.setPlane();
    }

    setCustomRender() {
        this.customRender = {};
        this.customRender.scene = new THREE.Scene();
        this.customRender.camera = new THREE.OrthographicCamera(
            -1,
            1,
            1,
            -1,
            0.1,
            10,
        );
    }

    setMaterial() {
        this.material = new NoisesMaterial();
    }

    setWorleyMaterial() {
        this.worleyMaterial = new WorleyMaterial();
    }

    setPlane() {
        this.plane = new THREE.Mesh(
            new THREE.PlaneGeometry(2, 2),
            this.material,
        );
        this.plane.frustumCulled = false;
        this.customRender.scene.add(this.plane);
    }

    create(width, height) {
        const renderTarget = new THREE.WebGLRenderTarget(width, height, {
            generateMipmaps: false,
            wrapS: THREE.RepeatWrapping,
            wrapT: THREE.RepeatWrapping,
        });
        this.plane.material = this.material;

        this.renderer.setRenderTarget(renderTarget);
        this.renderer.render(this.customRender.scene, this.customRender.camera);
        this.renderer.setRenderTarget(null);

        const texture = renderTarget.texture;
        // texture.wrapS = THREE.RepeatWrapping
        // texture.wrapT = THREE.RepeatWrapping

        if (this.helper) this.helper.material.map = texture;

        return renderTarget;
    }

    createWorley(width, height) {
        const renderTarget = new THREE.WebGLRenderTarget(width, height, {
            generateMipmaps: false,
            wrapS: THREE.RepeatWrapping,
            wrapT: THREE.RepeatWrapping,
        });
        this.plane.material = this.worleyMaterial;

        this.renderer.setRenderTarget(renderTarget);
        this.renderer.render(this.customRender.scene, this.customRender.camera);
        this.renderer.setRenderTarget(null);

        const texture = renderTarget.texture;
        // texture.wrapS = THREE.RepeatWrapping
        // texture.wrapT = THREE.RepeatWrapping

        if (this.helper) this.helper.material.map = texture;

        return renderTarget;
    }
}
